/**
 * Навигация консоли, сгруппированная по брифу:
 * Overview, Fleet, Operations, People, Communications, Management.
 *
 * Прежний ADMIN_TABS был плоским списком из шести эмодзи-пунктов.
 */
export const NAV_GROUPS = [
  {
    id: 'overview',
    label: 'Обзор',
    items: [
      { to: '/admin', icon: 'dashboard', label: 'Дашборд', end: true },
      { to: '/admin/infopanel', icon: 'columns', label: 'Информационная панель' },
    ],
  },
  {
    id: 'fleet',
    label: 'Автопарк',
    items: [
      { to: '/admin/cars', icon: 'car', label: 'Машины' },
      { to: '/admin/regions', icon: 'map', label: 'Регионы' },
    ],
  },
  {
    id: 'operations',
    label: 'Операции',
    items: [
      { to: '/admin/trips', icon: 'trips', label: 'Поездки' },
      { to: '/admin/tasks', icon: 'tasks', label: 'Задачи' },
      { to: '/admin/calendar', icon: 'calendar', label: 'Календарь' },
      { to: '/admin/reminders', icon: 'warning', label: 'Напоминания' },
    ],
  },
  {
    id: 'people',
    label: 'Люди',
    items: [
      { to: '/admin/users', icon: 'users', label: 'Пользователи' },
      { to: '/admin/structure', icon: 'map', label: 'Структура' },
      { to: '/admin/groups', icon: 'users', label: 'Группы' },
    ],
  },
  {
    id: 'communications',
    label: 'Коммуникации',
    items: [
      { to: '/admin/chats', icon: 'chat', label: 'Чаты' },
      // Пункт виден всегда, когда модуль включён; сама страница
      // показывает заглушку, если владелец модуль выключил.
      { to: '/admin/video', icon: 'chat', label: 'Видеозвонки' },
      { to: '/admin/tickets', icon: 'warning', label: 'Тикеты' },
      { to: '/admin/kb', icon: 'file', label: 'База знаний' },
    ],
  },
  {
    id: 'management',
    label: 'Управление',
    items: [
      { to: '/admin/analytics', icon: 'fuel', label: 'Аналитика' },
      { to: '/admin/logs', icon: 'file', label: 'Журналы' },
      // Правовые документы редактирует владелец. Пункт виден всем,
      // кто дошёл до консоли; сама страница проверяет роль и
      // объясняет отказ, а не молча исчезает из меню.
      { to: '/admin/settings', icon: 'settings', label: 'Настройки' },
    ],
  },
]

export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items)
